export default "/images/6dbb6e2dea8549239c6ee7ea8459578b.avif";